import { downloadRequest } from "@/utils/downloadRequest";
import { downloadFile, DownloadType } from "project-config/utils";

export const fileName = (url: string) => {
  const reg = new RegExp("/(?<=/)(?:(?:w+.)*w+)$/");
  const result = url.match(reg);
  return reg.test(url) && result ? result[0] : "";
};

export const handleDownload = async (invoiceOrderNumber: string) => {
  downloadRequest("/api/rendering/user/invoiceDownload", {
    invoiceOrderNumber,
  }).then((res) => {
    downloadFile(res as any, { downloadType: DownloadType.Pdf });
  });
};
